<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="#30A8FF"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0015 15.3385L6.34766 9.68468L7.27648 8.75586L12.0015 13.4809L16.7265 8.75586L17.6553 9.68468L12.0015 15.3385Z"
        />
      </svg>
</template>